import styled, { css } from "styled-components";

import { Search } from "../../styles/Icons";

import {
  Button as ButtonAnt,
  Input as InputAnt,
  Select as SelectAnt,
} from "antd";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.5rem;

  @media (max-width: 768px) {
    .ant-checkbox-wrapper {
      margin-left: 0;
    }
  }
`;

export const CardContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
`;

export const ContainerSearch = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (max-width: 992px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const BoxSearch = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;

  @media (max-width: 992px) {
    width: 100%;
  }

  @media (max-width: 576px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

export const Input = styled(InputAnt)`
  width: 20rem;

  @media (max-width: 992px) {
    width: 100%;
  }
`;

export const Select = styled(SelectAnt)`
  width: 10rem;
  border: 0.0625rem solid rgba(205, 207, 213, 0.5);
  .ant-select-arrow {
    color: var(--gray-550);
  }
  .ant-select-selector {
    height: 100% !important;
  }

  @media (max-width: 992px) {
    width: 100%;
  }
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  height: 100%;
  gap: 1rem;

  @media (max-width: 992px) {
    width: 100%;
    justify-content: space-between;
  }

  @media (max-width: 576px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

export const SearchIcon = styled(Search)`
  width: 1.2rem;
  height: 1.2rem;
  color: var(--gray-550);

  @media only screen and (max-width: 1366px) {
    width: 1rem;
    height: 1rem;
  }
`;

interface IButton {
  actionType:
    | "default"
    | "send"
    | "inactivate"
    | "activate"
    | "update_magic_link";
}

export const Button = styled(ButtonAnt)<IButton>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.3rem;
  white-space: normal;
  height: auto;
  padding: 0.25rem 0.3rem;
  min-height: 2rem;
  color: var(--white);

  &&&:disabled {
    background-color: #d4d4d4;
    color: #a09d9d;
    &&&:hover {
      background-color: #d4d4d4;
    }
  }

  ${({ actionType }) => {
    if (actionType === "default") {
      return css`
        background-color: var(--gray-100);
      `;
    }
    if (actionType === "send" || actionType === "update_magic_link") {
      return css`
        background-color: #1890ff;
        &&&:hover,
        &&&:focus,
        &&&:active,
        &&&:focus-within {
          background-color: rgb(53, 134, 209);
        }
      `;
    }
    if (actionType === "inactivate") {
      return css`
        background-color: var(--red-600);
        &&&:hover,
        &&&:focus,
        &&&:active,
        &&&:focus-within {
          background-color: rgb(209, 53, 53);
        }
      `;
    }
    if (actionType === "activate") {
      return css`
        background-color: var(--green-700);
        &&&:hover,
        &&&:focus,
        &&&:active,
        &&&:focus-within {
          background-color: rgb(45, 124, 45);
        }
      `;
    }
  }}

  @media (max-width: 576px) {
    width: 100%;
    font-size: 0.9rem;
    padding: 0.25rem 0.5rem;
    min-height: 2.25rem;
  }
`;

export const Country = styled.img`
  width: 1.5rem;
  height: 1.5rem;
`;

interface IStatusSpan {
  status: "success" | "error" | "info";
}

export const StatusSpan = styled.span<IStatusSpan>`
  color: ${({ status }) => {
    switch (status) {
      case "success":
        return "#52c41a";
      case "error":
        return "#ff4d4f";
      case "info":
      default:
        return "#1890ff";
    }
  }};
  font-weight: bold;
`;
